var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.role == 'pemohon')?_c('dashboard-standard'):_c('dashboard-admin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }